import { addPubParamToUrl as addPubParamToUrlFromPackage } from "@revbox/helpers-fe";
import { CRYPTO_KEY } from "./crypto";

export const addPubParamToUrl = (url, addPub = false, advertiserId) => {
  return addPubParamToUrlFromPackage(url, addPub, advertiserId, CRYPTO_KEY);
};
